import Swal from 'sweetalert2';
import { MapFactory } from '@dealersites/dealersite-js-core';
import { inventoryLocalization } from './translations';

const vehicleDistanceBlock = document.getElementById('dsp-vehicle-distance');

if (vehicleDistanceBlock) {
  const distanceOutput = vehicleDistanceBlock.querySelector('#dsp-distance-output');
  const postalCodeInput = vehicleDistanceBlock.querySelector('#dsp-postal-code-input');
  const getDistanceBtn = vehicleDistanceBlock.querySelector('#dsp-get-distance-btn');

  // Local cache postal code data.
  if (localStorage.getItem('userPostalCode') && postalCodeInput != null) {
    postalCodeInput.value = localStorage.getItem('userPostalCode');
  }

  /**
   * Setter for distance output div.
   *
   * @param   {string}  value  Information to display in UI
   */
  function setDistanceOutput(value) {
    distanceOutput.innerText = value;
  }

  /**
   * Set the values on UI depending if information is processing or not.
   *
   * @param {boolean} status Is the request in progress (true) or done (false).
   */
  function isLoading(status) {
    if (status) {
      postalCodeInput.disabled = true;
      getDistanceBtn.style.display = 'none';

      setDistanceOutput(inventoryLocalization.gettext('Loading...'));
      return;
    }

    postalCodeInput.disabled = false;
    getDistanceBtn.style.display = 'block';
  }

  /**
   * Calculates the distance between the supplied PostalCode
   * and the selected vehicle, sets the output on UI.
   */
  async function calculateDistance() {
    // UI update, let user know we are calculating distance.
    isLoading(true);

    const vehicleLocation = {
      lng: distanceOutput ? parseFloat(distanceOutput.dataset.lon) : '',
      lat: distanceOutput ? parseFloat(distanceOutput.dataset.lat) : '',
    };

    const map = MapFactory.createMap('google', {
      apiKey: DSP_GEOCODER_API_KEY || '',
      type: 'distance',
    });

    const distance = await map.getDistance(postalCodeInput.value, vehicleLocation);

    try {
      setDistanceOutput(distance);
      localStorage.setItem('userPostalCode', postalCodeInput.value);
    } catch (e) {
      Swal.fire(
        inventoryLocalization.gettext('Sorry'),
        inventoryLocalization.gettext(
          "We weren't able to find an address for the provided postal code."
        ),
        'warning'
      );
      setDistanceOutput('0 km');
    } finally {
      isLoading(false);
    }
  }

  getDistanceBtn.addEventListener('click', async () => {
    // TODO: Let the user know that they need to put a valid postal code.
    if (postalCodeInput.length < 0) {
      return;
    }

    await calculateDistance();
  });

  document.onreadystatechange = async () => {
    if (document.readyState === 'complete' && localStorage.getItem('userPostalCode') !== null) {
      await calculateDistance();
    }
  };
}
